import r from "./_baseAssignValue.js";
import s from "./eq.js";
function m(n, f, i) {
  (i !== void 0 && !s(n[f], i) || i === void 0 && !(f in n)) && r(n, f, i);
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_assignMergeValue.js
// module id = 902
// module chunks = 67